import * as React from 'react'
import { styled } from 'next-yak'

import * as link from '../styles/link'
import { PolymorphicComponent, PolymorphicProps, YakComponentOf } from '@owl-nest/yak/extra-runtime'

export type ExtraLinkProps = link.BaseLinkProps & {
  //children?: React.ReactNode
  /** Whether to use a darker blue tint. Only has effect on the primary link */
  darkened?: boolean
  kind?: 'primary' | 'inverted' | 'secondary' | 'important'
  /** Whether to add color tint to the link. Only has effect on the primary link */
  tinted?: boolean
}

export type LinkProps = ExtraLinkProps & PolymorphicProps<'a'>

const LinkComponent = React.forwardRef<HTMLAnchorElement, LinkProps>(function LinkComponent(
  { children, kind = 'primary', ...props },
  ref,
): React.ReactElement<LinkProps> {
  switch (kind) {
    case 'secondary':
      return (
        <link.Secondary ref={ref} {...props}>
          {children}
        </link.Secondary>
      )
    case 'inverted':
      return (
        <link.Inverted ref={ref} {...props}>
          {children}
        </link.Inverted>
      )
    case 'important':
      return (
        <link.Important ref={ref} {...props}>
          {children}
        </link.Important>
      )
    case 'primary':
    default:
      break
  }

  return (
    <link.Primary ref={ref} {...props}>
      {children}
    </link.Primary>
  )
})

export const Link = styled(LinkComponent)`` as YakComponentOf<PolymorphicComponent<'a', ExtraLinkProps>>
Link.displayName = 'Link'
